import { api } from "./api";

export const inventoryCreateApi = (params) => {
  return api.post(`/warehouse/create`, JSON.stringify(params));
};

export const binlocationAddApi = (params) => {
  return api.post(`/warehouse/addBinLocation`, JSON.stringify(params));
};

export const warehouseListApi = (params) => {
  return api.get(
    `/warehouse/getByWareHouseCode?warehouse_code=${params?.code}`
  );
};

export const warehouseGetIdApi = () => {
  return api.get(`/warehouse/getId`);
};

export const warehouseListWithCapacityApi = () => {
  return api.get(`/warehouse/getAllWithBinCapacity`);
};

export const warehouseBinListApi = (params) => {
  const query = new URLSearchParams();
  query.set("warehouse_id", params?.warehouse_id ?? "");
  query.set("pageNumber", params?.pageNumber ?? 1);
  query.set("pageSize", params?.pageSize ?? 10);
  if (params?.search) query.set("search", params.search);
  if (params?.selectColumn) query.set("selectColumn", params.selectColumn);
  if (params?.statusFilters?.length) {
    query.set("statusFilters", params.statusFilters.join(","));
  }
  return api.get(`/warehouse/getAllBinLocation/pagination?${query.toString()}`);
};

export const warehouseBinGenerateApi = (params) => {
  return api.post(`/warehouse/bin/generate`, JSON.stringify(params));
};

export const warehouseBinAddApi = (params) => {
  return api.post(`/warehouse/bin/add`, JSON.stringify(params));
};

export const warehouseBinUpdateApi = (params) => {
  return api.post(`/warehouse/bin/update`, JSON.stringify(params));
};

export const warehouseBinDeleteApi = (params) => {
  return api.post(`/warehouse/bin/delete`, JSON.stringify(params));
};

export const warehouseBinDefaultItemsAddApi = (params) => {
  return api.post(`/warehouse/bin/defaultItem/add`, JSON.stringify(params));
};

export const warehouseBinDefaultItemsListApi = (params) => {
  return api.get(
    `/warehouse/bin/defaultItem/get?bin_no_id=${params?.bin_no_id}`
  );
};

export const warehouseBinItemsListApi = (params) => {
  return api.get(`/warehouse/bin/items/${params?.bin_no_id}`);
};

export const warehouseExpiredItemsListApi = (params) => {
  return api.get(
    `/warehouse/expiredItems/get?warehouse_id=${params?.warehouse_id}&days=${params?.days}`
  );
};

export const warehouseBinSetDefaultApi = (params) => {
  return api.post(`/warehouse/bin/setDefault`, JSON.stringify(params));
};

export const stockTransferCreateApi = (params) => {
  return api.post(`/stock/transfer/create`, JSON.stringify(params));
};
export const stockTransferEditApi = (params) => {
  return api.post(`/stock/transfer/update`, JSON.stringify(params));
};
export const stockTransferDeclineApi = (params) => {
  return api.post(`/setStockTransferStatusDeclined/${params?.id}`);
};

export const stockTransferTableApi = (params) => {
  return api.get(
    `/stock/transfer/list?pageNumber=${params?.pageNumber}&pageSize=${
      params?.pageSize
    }&sortBy=${params?.filterData?.sort_by}&sortOrder=${
      params?.filterData?.sort_order
    }&fromDate=${params?.filterData?.from}&toDate=${params?.filterData?.to}${
      params?.filterData?.inputValue &&
      `&searchColumn=${params?.filterData?.selectColumn}&searchValue=${params?.filterData?.inputValue}`
    }&filterValue=${params?.filterData?.filterValue}`,
    JSON.stringify(params)
  );
};

export const stockTransferViewApi = (params) => {
  return api.get(
    `/stock/transfer/getById?itt_id=${params}`,
    JSON.stringify(params)
  );
};
export const stockTransferBatchApi = (params) => {
  return api.get(`/product/batchnumber/get?item_id=${params}`);
};
export const voidStockTransferApi = (params) => {
  return api.post(`/stock/transfer/void`, JSON.stringify(params));
};
export const voidStockTransferItemApi = (params) => {
  return api.post(`/stock/transfer/void/item`, JSON.stringify(params));
};
